import axios from 'axios';
import { useState, useEffect } from 'react';
import { SubmitButton } from '../../../../components/common/button/CustomButtons';
import GridInputs from '../../../../components/common/inputs/GridInputs';
import useConfirm from '../../../../components/common/useConfirm';
import { apiConstant } from '../helpers/constant';

const ModalInput = ({
  id,
  setIsModal,
  setUseEffectRender,
  setId,
}: {
  id?: string | null;
  setUseEffectRender: any;
  setId: any;
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [moduleData, setMoudleData] = useState<any>({ name: '' });
  const [DialogSubmit, confirmSubmit] = useConfirm(
    `${id ? 'Update Customer' : 'Create Customer'}`,
    `Are you sure you want to ${id ? 'update' : 'save'} this?`
  );

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/${apiConstant.rackroute}/${id}`)
        .then((res) => setMoudleData(res.data))
        .catch((err) => console.log(err));
    }
  }, [id]);

  function handleData(e: React.ChangeEvent<HTMLInputElement>) {
    setMoudleData((prev: any) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  }

  const handleSumbit = async () => {
    const ans = await confirmSubmit();
    if (!ans) return;
    if (id) {
      await axios
        .put(`/api/${apiConstant.rackroute}/${id}`, moduleData)
        .then((res) => {
          setIsModal(false);
          setId(null);
          setUseEffectRender((prev: any) => !prev);
        })
        .catch((err) => console.log(err));
    } else {
      await axios
        .post(`/api/${apiConstant.rackroute}`, moduleData)
        .then((res) => {
          setIsModal(false);
          setId(null);
          setUseEffectRender((prev: any) => !prev);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <>
      <GridInputs
        id={'name'}
        name={'name'}
        html_for={'name'}
        label_name={'Title'}
        input_type={'text'}
        focusType={'onblur'}
        value={moduleData?.name || ''}
        onChange={handleData}
        last_child={2}
      />
      <div
        className="btn_save"
        style={{
          position: 'absolute',
          right: '140px',
          top: '-0.6px',
        }}
      >
        <SubmitButton
          label={`${id ? 'update' : 'submit'}`}
          type="button"
          onClick={handleSumbit}
        />
      </div>
      <DialogSubmit />
    </>
  );
};

export default ModalInput;
